// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './lang'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import echarts from 'echarts'
import VueClipboard from 'vue-clipboard2' //复制
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

import './utils/flexible.js'

import '@/permission'

Vue.use(ElementUI)
Vue.use(i18n)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.hkdz = window.GLOBAL.hkdz;
document.title = window.GLOBAL.TITLE[store.state.lang]

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n,
  store
})



// WEBPACK FOOTER //
// ./src/main.js